// @ts-nocheck
import * as React from "react";
import { Logo, Ic, Sidebar, Topbar, GuardianTabBar, ElderTabBar, RoleTabBar, AvatarEditor, ProfileEditor, PasswordChanger, AccountWithdraw, NotificationPreferences, LineChart, BarChart, Kpi, useCurrentUser, MessageComposer, NotifyFeed, PhoneInput, apiErrorMessage, supportPhone } from "./common";

const ELDER_CONSULT_TEL = supportPhone();

// "오전 10:00" — 24시제 금지(어르신 가독성). 어르신 화면 공용.
function elderTime(d) {
  return d.toLocaleTimeString("ko-KR", { hour: "numeric", minute: "2-digit" });
}
// 주격 조사 이/가 — 받침 유무. "선생님이"/"이미경 매니저가".
function elderJosa(word) {
  const last = (word || "").charCodeAt((word || "").length - 1);
  if (Number.isNaN(last) || last < 0xac00 || last > 0xd7a3) return "가";
  return (last - 0xac00) % 28 !== 0 ? "이" : "가";
}
// 자격 → 일상 호칭. 어르신 홈(dashboard-elder)과 동일 규칙. 자격 미상이면 "님".
function elderHonorific(qual) {
  if (!qual) return "님";
  if (qual.includes("요양보호")) return "요양보호사님";
  if (qual.includes("간호"))     return "간호사님";
  if (qual.includes("사회복지")) return "선생님";
  return "매니저";
}
const ELDER_WEEK = ["일", "월", "화", "수", "목", "금", "토"];

// 복약 시간대 파싱. time_of_day 가 "아침/저녁"·"아침·저녁"·"취침 전"·nil 등으로 섞여
// 들어오므로 구분자(/·,、공백)로 쪼개 표준 슬롯으로 정규화한다. 미상/빈값 → [](="시간 미지정").
// 설계: docs/elder-meds-screen-design.md §6
const MED_SLOTS = ["아침", "점심", "저녁", "취침 전"];
// 알림 link 의 ?s=<key> → 슬롯 라벨. 백엔드 Medication::SLOT_KEYS 와 동일.
const MED_SLOT_BY_KEY = { morning: "아침", noon: "점심", evening: "저녁", bedtime: "취침 전" };
function parseMedSlots(tod) {
  if (!tod) return [];
  const out = [];
  String(tod).split(/[\/·,、\s]+/).forEach((tok) => {
    const t = tok.trim();
    if (!t) return;
    let slot = null;
    if (t.includes("아침")) slot = "아침";
    else if (t.includes("점심")) slot = "점심";
    else if (t.includes("저녁")) slot = "저녁";
    else if (t.includes("취침") || t.includes("자기") || t.includes("잘")) slot = "취침 전";
    if (slot && !out.includes(slot)) out.push(slot);
  });
  return out;
}

// 어르신 화면의 빈/오류 상태 공통. 빨간 에러 대신 상담센터 전화로 안내.
function ElderNotice({ active, title, desc }) {
  return (
    <div className="app" style={{ background: "var(--bg)", overflow: "hidden", display: "flex", flexDirection: "column" }}>
      <SbarG/>
      <div style={{ padding: "12px 22px 4px" }}><div style={{ fontSize: 21, fontWeight: 800 }}>{title}</div></div>
      <div style={{ flex: 1, display: "flex", flexDirection: "column", justifyContent: "center", padding: "0 22px" }}>
        <div className="card" style={{ padding: 20, borderRadius: 18, textAlign: "center" }}>
          <div style={{ fontSize: 15, color: "var(--ink-2)", lineHeight: 1.6, marginBottom: 18 }}>{desc}</div>
          <a href={`tel:${ELDER_CONSULT_TEL}`} className="btn btn-secondary"
             style={{ width: "100%", height: 54, fontSize: 16, fontWeight: 700, textDecoration: "none", display: "flex", justifyContent: "center", alignItems: "center", gap: 8 }}>
            <span style={{ width: 20, height: 20, display: "inline-block" }}>{Ic.phone}</span>
            상담센터 전화 ({ELDER_CONSULT_TEL})
          </a>
        </div>
      </div>
      <ElderTabBar active={active}/>
      <HbarG/>
    </div>
  );
}
import { api } from "../api";
import { LocationPicker } from "../components/naver/LocationPicker";
import { RatingModal } from "../components/RatingModal";

const SbarG = () => (
  <div style={{display:'flex', justifyContent:'space-between', padding:'8px 22px 4px', fontSize:11, fontWeight:600, color:'var(--ink-1)', flex:'0 0 auto'}}>
    <span>{new Date().toLocaleTimeString('ko-KR',{hour:'2-digit',minute:'2-digit'})}</span>
    <div style={{display:'flex', gap:5, alignItems:'center'}}>
      <span>●●●</span><span style={{fontSize:10}}>5G</span>
      <span style={{width:18, height:9, border:'1px solid var(--ink-1)', borderRadius:2, position:'relative'}}><span style={{position:'absolute', inset:1, background:'var(--ink-1)'}}/></span>
    </div>
  </div>
);
const HbarG = () => <div style={{height:4, width:120, background:'var(--ink-1)', borderRadius:99, margin:'2px auto 6px'}}/>;

// Required fields drive the progress bar + final submit guard. Splitting
// them out as a constant keeps "필수" semantics in one place — if a new
// field becomes mandatory, this is the only line to touch.
const CARE_APPLY_REQUIRED = ["applicant_name", "applicant_phone", "elderly_name", "elderly_address"];

// Loose 휴대폰 패턴 — 010-1234-5678 / 01012345678 / +82 모두 허용. UX는
// 강제하지 않고 힌트만 표시해 신청 진입 장벽을 낮춘다.
const PHONE_HINT_PATTERN = /^(\+?82-?)?0?1\d-?\d{3,4}-?\d{4}$/;

function isFilled(v) {
  if (v == null) return false;
  if (typeof v === "string") return v.trim().length > 0;
  if (typeof v === "number") return !Number.isNaN(v);
  return true;
}

// api.ts wraps any non-2xx into a plain Error whose message is
// "<status> <statusText> <json-body>". We pull the structured details
// out so the user sees the validation messages instead of an opaque
// "422 Unprocessable Entity {…}" string. Falls back to the raw message
// if parsing fails.
function humanCareApplyError(e) {
  if (!e) return "신청 접수에 실패했습니다.";
  const msg = e.message || "";
  if (msg.includes(" 401 ")) return "로그인이 필요합니다.";
  if (msg.includes(" 403 ")) return "권한이 없습니다.";
  const match = msg.match(/\{.*\}$/);
  if (match) {
    try {
      const body = JSON.parse(match[0]);
      if (Array.isArray(body.details) && body.details.length) return body.details.join(", ");
      if (body.message) return body.message;
      if (body.error) return body.error;
    } catch { /* fall through */ }
  }
  return "신청 접수에 실패했습니다. 잠시 후 다시 시도해주세요.";
}

// Time to keep the success screen on-screen before the auto-redirect to
// the mobile landing — long enough to read, short enough to feel snappy.
const CARE_APPLY_REDIRECT_MS = 3000;

// 케어 신청 진입 게이트 확인 중/리다이렉트 중 표시할 최소 화면.
function CareApplyGate() {
  return (
    <div className="app" style={{background:'var(--bg)', display:'grid', placeItems:'center'}}>
      <div style={{fontSize:13, color:'var(--ink-3)'}}>확인 중…</div>
    </div>
  );
}

// 1. 케어 신청 (POST)
function CareApply() {
  const { user, loaded } = useCurrentUser();
  // 진입 게이트: "checking" 동안은 폼을 감추고, 로그인 보호자/어르신이 이미 진행 중인
  // 케어 요청을 보유하면 폼 대신 홈으로 돌려보낸다(백엔드도 409로 막지만 화면 단에서
  // 먼저 차단). 비로그인 공개 신청, 또는 반려/미신청/어르신 미연결은 폼을 노출한다.
  const [gate, setGate] = React.useState("checking"); // checking | open | redirecting
  React.useEffect(() => {
    if (!loaded) return;
    if (!user || (user.role !== "guardian" && user.role !== "citizen")) { setGate("open"); return; }
    let alive = true;
    fetch("/api/v1/dashboard/guardian", { credentials: "same-origin" })
      .then(r => r.ok ? r.json() : null)
      .then(d => {
        if (!alive) return;
        const stage = d?.care_status?.stage;
        if (stage && stage !== "rejected" && stage !== "none") {
          setGate("redirecting");
          window.location.href = user.default_path || "/dashboard/guardian";
        } else {
          setGate("open");
        }
      })
      .catch(() => { if (alive) setGate("open"); });
    return () => { alive = false; };
  }, [user, loaded]);

  const [form, setForm] = React.useState({
    elderly_name: "",
    elderly_age: 75,
    elderly_address: "",
    household_type: "독거",
    health_status: "",
    ltci_grade: "3등급",
    nhi_linked: true,
    applicant_name: "",
    applicant_relation: "자녀",
    applicant_phone: "",
    latitude: null,
    longitude: null,
  });
  const [savedId, setSavedId] = React.useState(null);
  const [submitting, setSubmitting] = React.useState(false);
  const [err, setErr] = React.useState(null);
  const set = (k) => (v) => setForm(f => ({ ...f, [k]: v }));

  // Live completion percent based on required fields. Optional fields
  // (health_status, household_type, ltci_grade) are intentionally
  // excluded so the bar reflects "ready to submit" rather than "all
  // fields touched".
  const progressPct = React.useMemo(() => {
    const filled = CARE_APPLY_REQUIRED.filter(k => isFilled(form[k])).length;
    return Math.round((filled / CARE_APPLY_REQUIRED.length) * 100);
  }, [form]);

  const requiredOk = progressPct === 100;
  const phoneLooksValid = !form.applicant_phone || PHONE_HINT_PATTERN.test(form.applicant_phone.trim());

  const submit = async () => {
    if (submitting || savedId) return;
    setErr(null);
    setSubmitting(true);
    try {
      const r = await api.create("care_applications", form);
      setSavedId(r.id);
      // 성공 후 잠시 대기해 사용자가 접수 번호를 인지하도록 한 뒤 랜딩으로.
      window.setTimeout(() => { window.location.href = "/m"; }, CARE_APPLY_REDIRECT_MS);
    } catch (e) {
      setErr(humanCareApplyError(e));
    } finally {
      setSubmitting(false);
    }
  };

  // 성공 화면은 폼 분기로 분리. 사용자가 뒤로 가기로 다시 폼에 진입하는 걸
  // 막지는 않지만 (브라우저 history), 자동 리다이렉트로 흐름이 끊기지 않도록
  // 한다.
  if (gate !== "open") return <CareApplyGate/>;
  if (savedId) return <CareApplySuccess savedId={savedId}/>;

  return (
    <div className="app" style={{background:'var(--bg)', overflow:'hidden'}}>
      <SbarG/>
      <div style={{padding:'8px 22px 12px', display:'flex', alignItems:'center', gap:14}}>
        <a href="/m" aria-label="홈으로"
           style={{width:32, height:32, display:'grid', placeItems:'center', borderRadius:10, background:'var(--surface)', color:'var(--ink-1)', textDecoration:'none'}}>‹</a>
        <div style={{flex:1}}>
          <div style={{fontSize:11, color:'var(--ink-3)'}}>케어 신청</div>
          <div style={{fontSize:14, fontWeight:700}}>어머니 정보를 알려주세요</div>
        </div>
        <div className="mono" style={{fontSize:11, color:'var(--ink-3)', fontWeight:700}}>{progressPct}%</div>
      </div>

      <div style={{padding:'0 22px 16px'}}>
        <div className="bar" style={{height:4}}>
          <span style={{width:`${progressPct}%`, background: requiredOk ? 'var(--green-500)' : 'var(--orange-500)'}}/>
        </div>
      </div>

      {err && <div role="alert" style={{margin:'0 22px 12px', padding:12, background:'var(--rose-50)', color:'var(--rose-500)', borderRadius:10, fontSize:12}}>{err}</div>}

      <div style={{padding:'4px 22px 0', flex:1, overflow:'auto'}}>
        <div style={{fontSize:11, fontWeight:700, color:'var(--ink-2)', letterSpacing:'0.06em', marginBottom:8}}>신청자(보호자) 정보</div>
        <div style={{display:'grid', gridTemplateColumns:'2fr 1fr', gap:10, marginBottom:14}}>
          <div>
            <div className="label">신청자 이름 <span style={{color:'var(--rose-500)'}}>*</span></div>
            <input className="input" value={form.applicant_name} onChange={e=>set('applicant_name')(e.target.value)} placeholder="박지영"/>
          </div>
          <div>
            <div className="label">관계</div>
            <select className="select" value={form.applicant_relation} onChange={e=>set('applicant_relation')(e.target.value)}>
              <option>자녀</option><option>배우자</option><option>본인</option><option>기타</option>
            </select>
          </div>
        </div>
        <div className="label">연락처 <span style={{color:'var(--rose-500)'}}>*</span></div>
        <PhoneInput value={form.applicant_phone} onChange={e=>set('applicant_phone')(e.target.value)} placeholder="010-1234-5678"
          style={{marginBottom: phoneLooksValid ? 18 : 4}}/>
        {!phoneLooksValid && (
          <div className="muted" style={{fontSize:11, color:'var(--amber-700)', marginBottom:14}}>
            ⓘ 010-1234-5678 형식을 확인해주세요
          </div>
        )}

        <div style={{fontSize:11, fontWeight:700, color:'var(--ink-2)', letterSpacing:'0.06em', marginBottom:8}}>어르신 정보</div>
        <div className="label">성함 <span style={{color:'var(--rose-500)'}}>*</span></div>
        <input className="input" value={form.elderly_name} onChange={e=>set('elderly_name')(e.target.value)} placeholder="박순자" style={{marginBottom:14}}/>

        <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:14}}>
          <div>
            <div className="label">나이</div>
            <input className="input" type="number" value={form.elderly_age} onChange={e=>set('elderly_age')(+e.target.value)}/>
          </div>
          <div>
            <div className="label">장기요양 등급</div>
            <select className="select" value={form.ltci_grade} onChange={e=>set('ltci_grade')(e.target.value)}>
              <option>1등급</option><option>2등급</option><option>3등급</option><option>4등급</option><option>5등급</option><option>미신청</option>
            </select>
          </div>
        </div>

        <div className="label">거주지 주소 <span style={{color:'var(--rose-500)'}}>*</span></div>
        <input className="input" value={form.elderly_address} onChange={e=>set('elderly_address')(e.target.value)} placeholder="인천 부평구 산곡동 …" style={{marginBottom:12}}/>

        <div className="label">거주지 위치 (지도에서 지정 · 매칭 거리 계산에 사용)</div>
        <div style={{marginBottom:16}}>
          <LocationPicker
            value={form.latitude != null && form.longitude != null ? { lat: form.latitude, lng: form.longitude } : null}
            onChange={(c) => setForm(f => ({ ...f, latitude: c.lat, longitude: c.lng }))}
          />
        </div>

        <div style={{fontSize:11, fontWeight:700, color:'var(--ink-2)', letterSpacing:'0.06em', margin:'6px 0 8px'}}>거주 형태</div>
        <div style={{display:'grid', gridTemplateColumns:'1fr 1fr', gap:8, marginBottom:18}}>
          {['독거','배우자와','자녀와','요양시설'].map((t)=>(
            <div key={t} onClick={()=>set('household_type')(t)} style={{padding:12, borderRadius:10, background: form.household_type===t?'var(--orange-50)':'var(--surface)', border: form.household_type===t?'1.5px solid var(--orange-500)':'1px solid var(--border)', textAlign:'center', fontSize:13, fontWeight:600, color: form.household_type===t?'var(--orange-700)':'var(--ink-2)', cursor:'pointer'}}>{t}</div>
          ))}
        </div>

        <div className="label">건강 상태 (간단히)</div>
        <textarea className="input" rows={3} value={form.health_status} onChange={e=>set('health_status')(e.target.value)} placeholder="예: 고혈압·당뇨, 보행 보조 필요"/>

        <div style={{padding:12, background:'var(--green-50)', borderRadius:12, display:'flex', alignItems:'flex-start', gap:10, margin:'18px 0'}}>
          <input type="checkbox" checked={form.nhi_linked} onChange={e=>set('nhi_linked')(e.target.checked)} style={{marginTop:2}}/>
          <div style={{flex:1}}>
            <div style={{fontSize:12, fontWeight:700, color:'var(--green-700)'}}>국민건강보험 정보 연계 동의</div>
            <div className="muted" style={{fontSize:11, marginTop:2}}>장기요양·의료기록 자동 가져옴</div>
          </div>
        </div>
      </div>

      <div style={{padding:'14px 22px', borderTop:'1px solid var(--border-soft)', display:'flex', gap:8, background:'var(--surface)'}}>
        <a href="/m" className="btn btn-ghost btn-lg"
           style={{flex:1, textDecoration:'none', display:'inline-flex', justifyContent:'center'}}>
          이전
        </a>
        <button type="button" className="btn btn-primary btn-lg" style={{flex:2}}
          onClick={submit}
          disabled={!requiredOk || submitting}
          aria-disabled={!requiredOk || submitting}>
          {submitting ? '제출 중…' : '제출 →'}
        </button>
      </div>
      <HbarG/>
    </div>
  );
}

// Post-submit confirmation. Sits between the form and the mobile landing
// so the applicant sees the접수 번호 and a clear next step. The form
// schedules a setTimeout to land here, then auto-redirect off into /m;
// this component keeps the rendering of that intermediate state isolated.
function CareApplySuccess({ savedId }) {
  return (
    <div className="app" style={{background:'var(--bg)', display:'flex', flexDirection:'column', height:'100%'}}>
      <SbarG/>
      <div style={{flex:1, display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', padding:'40px 24px', textAlign:'center'}}>
        <div style={{width:72, height:72, borderRadius:'50%', background:'var(--green-50)', color:'var(--green-600)', display:'grid', placeItems:'center', fontSize:36, marginBottom:18}}>
          ✓
        </div>
        <div style={{fontSize:18, fontWeight:800, marginBottom:8}}>신청이 접수되었습니다</div>
        <div className="muted" style={{fontSize:13, lineHeight:1.6, maxWidth:280}}>
          접수번호 <span className="mono" style={{color:'var(--ink-1)', fontWeight:700}}>#{savedId}</span>
          <br/>권역 관리자 검토 후 매니저가 배정됩니다.
        </div>
        <div className="muted" style={{fontSize:11, marginTop:18}}>
          잠시 후 홈으로 이동합니다…
        </div>
        <a href="/m" className="btn btn-primary btn-lg" style={{marginTop:18, textDecoration:'none', minWidth:220, display:'inline-flex', justifyContent:'center'}}>
          지금 홈으로 →
        </a>
      </div>
      <HbarG/>
    </div>
  );
}

// 2. 알림함 (보호자)
// 보호자 알림함 = 보호자 chrome(상태바·GuardianTabBar·홈바) + 공용 NotifyFeed.
// 목록/필터/읽음/삭제 로직은 common.tsx의 NotifyFeed가 단일 소스로 보유한다
// (매니저 MgrNotify도 같은 피드를 매니저 chrome으로 감싼다).
function NotifyCenter() {
  return (
    <div className="app" style={{background:'var(--bg)', overflow:'hidden'}}>
      <SbarG/>
      <NotifyFeed/>
      <RoleTabBar active="notify"/>
      <HbarG/>
    </div>
  );
}

function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}

// 3. 방문 이력 타임라인
function VisitTimeline() {
  const [data, setData] = React.useState(null);
  const [err, setErr]   = React.useState(null);
  const { user } = useCurrentUser();
  const isElder = user?.role === "citizen";
  // 평가 모달 대상 방문 + 제출된 별점(visit_id→stars) 즉시 반영용 오버라이드.
  const [ratingVisit, setRatingVisit] = React.useState(null);
  const [myRatings, setMyRatings] = React.useState({});
  // 어르신 방문 목록: 처음엔 일부만, "전체 보기"로 펼친다(긴 목록 압도 방지).
  const [showAllVisits, setShowAllVisits] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch("/api/v1/mobile/case", { credentials: "same-origin" });
        const body = await r.json().catch(() => null);
        if (cancelled) return;
        if (!r.ok) {
          if (r.status === 401)      setErr("로그인이 필요합니다.");
          else if (r.status === 403) setErr(body?.message || "이 케이스를 볼 권한이 없습니다.");
          else if (r.status === 404) setErr(body?.message || "표시할 케이스가 없습니다.");
          else                       setErr(apiErrorMessage(body, r.status));
          return;
        }
        setErr(null);
        setData(body);
      } catch (e) {
        if (!cancelled) setErr(apiErrorMessage(e));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  if (err) {
    if (isElder) return <ElderNotice active="schedule" title="방문 일정"
      desc={<>일정을 불러오지 못했어요.<br/>계속 안 되면 상담센터로 전화 주세요.</>} />;
    return <div className="app" style={{padding:40, color:'var(--rose-500)'}}>API 오류: {err}</div>;
  }
  if (!data) return <div className="app muted" style={{padding:40, fontSize: isElder ? 15 : undefined}}>불러오는 중…</div>;

  // ── 어르신(citizen) 1인칭 일정 화면 ──────────────────────────────
  // 보호자 화면(3인칭 "OOO 어르신", 11~12.5px, 활력 중심)과 달리, "다음에 누가
  // 언제 오나"를 크게 1인칭으로. 임상 수치(혈압 등)는 맨 아래 부가. 같은 데이터
  // (mobile/case)를 재사용하고 표시만 바꾼다. 설계: docs/elder-screens-design.md 4.2
  if (isElder) {
    const upcoming = data.upcoming_visits || [];
    const past = data.past_visits || [];
    const next = upcoming[0];
    const weekN = data.this_week_visit_count ?? 0;
    const vitals = data.recent_vitals || [];
    const rows = [...upcoming, ...past];
    const VISIT_PREVIEW = 4; // 처음 노출 건수 — 나머지는 "전체 보기"로
    const shownRows = showAllVisits ? rows : rows.slice(0, VISIT_PREVIEW);

    const nextDt = next ? new Date(next.scheduled_at) : null;
    const nextToday = nextDt ? isSameDay(nextDt, new Date()) : false;
    const nextWho = next ? `${next.manager_name} ${elderHonorific(next.qualification)}` : null;

    // 다크 요약카드 3-타일 — 어르신 홈(dashboard-elder)과 동일 레이아웃.
    const tiles = [
      { l: "이번 주",   v: `${weekN}번`,                                   s: "방문",                            c: "#fff" },
      { l: "담당",      v: next ? next.manager_name : (rows[0]?.manager_name || "-"), s: next ? elderHonorific(next.qualification) : "", c: "#fff" },
      { l: "최근 활력", v: vitals[0]?.bp || "-",                            s: vitals[0] ? "혈압" : "기록 없음",    c: "#9BD0AA" },
    ];

    return (
      <div className="app" style={{ background: "var(--bg)", overflow: "auto", display: "flex", flexDirection: "column" }}>
        <SbarG/>

        {/* ① 헤더 — 뒤로 + 제목(홈 헤드라인과 같은 20px) */}
        <div style={{ padding: "8px 22px 6px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
          <a onClick={() => history.back()} aria-label="뒤로"
             style={{ width: 40, height: 40, display: "grid", placeItems: "center", borderRadius: 12, background: "var(--surface)", color: "var(--ink-1)", fontSize: 22, cursor: "pointer", textDecoration: "none" }}>‹</a>
          <div style={{ fontSize: 20, fontWeight: 800 }}>방문 일정</div>
        </div>

        {/* ② 다크 요약 카드 — 홈과 동일 chrome(그라데이션/원형 장식/3타일). 주인공은 다음 방문. */}
        <div style={{ margin: "8px 22px 0", padding: 18, background: "linear-gradient(135deg, #2A241F, #3E3329)", color: "#F5EBD8", borderRadius: 18, position: "relative", overflow: "hidden", flexShrink: 0 }}>
          <div style={{ position: "absolute", top: -40, right: -30, width: 140, height: 140, borderRadius: "50%", background: "rgba(232,130,91,0.15)" }} />
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div className="avatar lg" style={{ background: "linear-gradient(135deg, #EFB287, #E8825B)" }}>
              <span style={{ width: 22, height: 22, display: "grid", placeItems: "center", fontSize: 22 }}>{next ? Ic.schedule : Ic.clock}</span>
            </div>
            <div style={{ minWidth: 0 }}>
              <div style={{ fontSize: 13, opacity: .7 }}>{nextToday ? "오늘 방문" : "다음 방문"}</div>
              <div style={{ fontSize: 18, fontWeight: 800, color: "#fff" }}>
                {next ? `${nextToday ? "" : ELDER_WEEK[nextDt.getDay()] + "요일 "}${elderTime(nextDt)}` : "예정된 방문이 없어요"}
              </div>
              {next && <div style={{ fontSize: 12, color: "#A89A7C", marginTop: 2 }}>{nextWho}{elderJosa(nextWho)} 오세요</div>}
            </div>
            {next && (
              <span style={{ marginLeft: "auto", padding: "4px 10px", background: nextToday ? "rgba(232,130,91,0.20)" : "rgba(143,200,168,0.20)", color: nextToday ? "#E8A05B" : "#9BD0AA", borderRadius: 999, fontSize: 12, fontWeight: 700, whiteSpace: "nowrap" }}>{nextToday ? "오늘" : "도착 예정"}</span>
            )}
          </div>
          <div style={{ display: "flex", gap: 8, marginTop: 14 }}>
            {tiles.map((t, i) => (
              <div key={i} style={{ flex: 1, padding: 10, background: "rgba(255,255,255,0.06)", borderRadius: 10, overflow: "hidden" }}>
                <div style={{ fontSize: 11, opacity: .65 }}>{t.l}</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: t.c, marginTop: 2, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>{t.v}</div>
                <div style={{ fontSize: 10, color: "#A89A7C", marginTop: 1, textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap" }}>{t.s}</div>
              </div>
            ))}
          </div>
        </div>

        {/* ③ 방문 목록 — 홈 "방문 일정" 카드와 동일 행 스타일(날짜블록 + 시각·호칭 + 배지). */}
        <div style={{ padding: "18px 22px 0" }}>
          <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 10 }}>방문 목록</div>
          <div className="card" style={{ padding: "4px 18px", borderRadius: 14 }}>
            {rows.length === 0 && <div className="muted" style={{ fontSize: 14 }}>아직 방문 기록이 없어요.</div>}
            {shownRows.map((v, i) => {
              const dt = new Date(v.scheduled_at);
              const today = isSameDay(dt, new Date());
              const done = v.status === "completed";
              const stars = myRatings[v.id] ?? v.my_rating;
              return (
                <div key={v.id} style={{ padding: "12px 0", borderTop: i > 0 ? "1px solid var(--border-soft)" : "none" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <div style={{ textAlign: "center", minWidth: 34 }}>
                      <div style={{ fontSize: 11, fontWeight: 700, color: "var(--ink-3)" }}>{ELDER_WEEK[dt.getDay()]}</div>
                      <div style={{ fontSize: 20, fontWeight: 800, color: today ? "var(--orange-600)" : "var(--ink-1)", lineHeight: 1 }}>{dt.getDate()}</div>
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 14, fontWeight: 600 }}>{elderTime(dt)} · {v.manager_name} {elderHonorific(v.qualification)}</div>
                    </div>
                    <span className={"badge " + (done ? "badge-green" : today ? "badge-orange" : "badge-gray")} style={{ fontSize: 13 }}>{done ? "다녀감" : today ? "오늘" : "예정"}</span>
                  </div>
                  {done && v.care_manager_id && (stars ? (
                    <div style={{ marginLeft: 46, marginTop: 8, fontSize: 16, color: "var(--amber-600)", fontWeight: 700 }}>
                      {"★".repeat(stars)}<span className="muted" style={{ fontWeight: 400, marginLeft: 6, fontSize: 13 }}>평가함</span>
                    </div>
                  ) : (
                    <button type="button" className="btn btn-ghost" style={{ marginLeft: 46, marginTop: 8, fontSize: 14, padding: "8px 14px" }}
                      onClick={() => setRatingVisit(v)}>별점 평가</button>
                  ))}
                </div>
              );
            })}
          </div>
          {rows.length > VISIT_PREVIEW && (
            <button type="button" onClick={() => setShowAllVisits((v) => !v)}
              style={{ width: "100%", marginTop: 10, padding: "13px 0", borderRadius: 12, border: "1px solid var(--border)",
                       background: "var(--surface)", color: "var(--orange-600)", fontSize: 15, fontWeight: 700, cursor: "pointer" }}>
              {showAllVisits ? "접기" : `전체 보기 (${rows.length}건)`}
            </button>
          )}
        </div>

        {/* ④ 지난 방문 건강 기록 — 홈 섹션 헤더/카드 스타일과 동일. */}
        {vitals.length > 0 && (
          <div style={{ padding: "18px 22px 0" }}>
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 10 }}>지난 방문 건강 기록</div>
            <div className="card" style={{ padding: "4px 18px", borderRadius: 14 }}>
              {vitals.slice(0, 3).map((v, i) => (
                <div key={v.id} style={{ padding: "12px 0", borderTop: i > 0 ? "1px solid var(--border-soft)" : "none", fontSize: 14 }}>
                  <span style={{ color: "var(--ink-3)" }}>{new Date(v.at).toLocaleDateString("ko-KR")}</span>{" · "}
                  {v.bp && <span>혈압 {v.bp}</span>}{v.hr && <span> · 맥박 {v.hr}</span>}{v.temp && <span> · 체온 {v.temp}°</span>}
                </div>
              ))}
            </div>
          </div>
        )}

        <div style={{ height: 14 }} />
        <div style={{ marginTop: "auto" }}><ElderTabBar active="schedule" /></div>
        <HbarG/>
        {ratingVisit && (
          <RatingModal
            visit={ratingVisit}
            onClose={() => setRatingVisit(null)}
            onSubmitted={(s) => { setMyRatings((m) => ({ ...m, [ratingVisit.id]: s })); setRatingVisit(null); }}
          />
        )}
      </div>
    );
  }

  const e = data.elderly;
  // 백엔드는 upcoming_visits / past_visits 두 배열로 분리해 보낸다.
  // 타임라인은 한 화면에서 함께 보여주므로 시간 오름차순으로 머지(예정 → 지난 순).
  const visits = [...(data.upcoming_visits || []), ...(data.past_visits || [])];
  // 이번 주 방문 수/시간은 백엔드가 별도 집계로 내려준다 — 머지된 배열 길이는
  // CASE_VISITS_SECTION_LIMIT(예: 5+5)에 잘릴 수 있어 그대로 쓰면 부정확.
  // 시간은 분 단위 합계 → 0.5h 단위로 반올림 표시(60분 미만 잘리는 것 방지).
  const weekVisits = data.this_week_visit_count ?? 0;
  const weekMinutes = data.this_week_total_minutes ?? 0;
  const weekHours = (Math.round((weekMinutes / 60) * 2) / 2).toFixed(1).replace(/\.0$/, '');

  return (
    <div className="app" style={{background:'var(--bg)', overflow:'hidden'}}>
      <SbarG/>
      <div style={{padding:'8px 22px 12px', display:'flex', alignItems:'center', gap:14}}>
        <a onClick={() => history.back()} style={{width:32, height:32, display:'grid', placeItems:'center', borderRadius:10, background:'var(--surface)', color:'var(--ink-1)', cursor:'pointer', textDecoration:'none'}}>‹</a>
        <div style={{flex:1}}>
          <div style={{fontSize:11, color:'var(--ink-3)'}}>방문 이력</div>
          <div style={{fontSize:14, fontWeight:700}}>{e.name} 어르신</div>
        </div>
      </div>

      <div style={{padding:'4px 22px 14px'}}>
        <div className="card" style={{padding:16, background:'linear-gradient(135deg, var(--orange-50), var(--bg-sub))', border:'1px solid var(--orange-100)'}}>
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6}}>
            <div style={{fontSize:13, fontWeight:800}}>이번 주</div>
            <span className="badge badge-green">진행중</span>
          </div>
          <div style={{display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10}}>
            {[
              { l:'방문', v:`${weekVisits}회`, c:'orange' },
              { l:'시간', v:`${weekHours}h`, c:'green' },
              { l:'활력', v: data.recent_vitals[0]?.bp || '-', c:'sky' },
            ].map((s,i)=>(
              <div key={i}>
                <div className="muted" style={{fontSize:10, fontWeight:600}}>{s.l}</div>
                <div style={{fontSize:18, fontWeight:800, color:`var(--${s.c}-600)`, marginTop:2}}>{s.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{padding:'0 22px 14px', flex:1, overflow:'auto'}}>
        <div style={{fontSize:11, fontWeight:700, color:'var(--ink-3)', letterSpacing:'0.06em', margin:'4px 0 10px'}}>이번 주</div>
        {visits.length === 0 && <div className="muted" style={{fontSize:12, textAlign:'center', padding:'30px 0'}}>방문 기록이 없습니다.</div>}
        {visits.map((v, i) => {
          const dt = new Date(v.scheduled_at);
          const isToday = isSameDay(dt, new Date());
          const isCompleted = v.status === 'completed';
          const c = isCompleted ? 'green' : isToday ? 'orange' : 'gray';
          return (
            <div key={v.id} style={{display:'flex', gap:14, marginBottom:14}}>
              <div style={{textAlign:'center', minWidth:36}}>
                <div style={{fontSize:11, color:'var(--ink-3)', fontWeight:700}}>{['일','월','화','수','목','금','토'][dt.getDay()]}</div>
                <div style={{fontSize:22, fontWeight:800, color: isToday ? 'var(--orange-600)' : 'var(--ink-1)', lineHeight:1}}>{dt.getDate()}</div>
              </div>
              <div className="card" style={{flex:1, padding:14, border: isToday ? '1.5px solid var(--orange-500)' : '1px solid var(--border-soft)'}}>
                <div style={{display:'flex', alignItems:'center', gap:10}}>
                  <div className={"avatar sm " + (i%2?'green':'')}>{v.manager_name[0]}</div>
                  <div style={{flex:1, minWidth:0}}>
                    <div style={{fontSize:12.5, fontWeight:700}}>{dt.toLocaleTimeString('ko-KR',{hour:'2-digit',minute:'2-digit'})} · {v.manager_name}</div>
                  </div>
                  <span className={"badge badge-" + c}>{isCompleted ? '완료' : isToday ? '오늘' : '예정'}</span>
                </div>
                {isCompleted && v.care_manager_id && (() => {
                  const stars = myRatings[v.id] ?? v.my_rating;
                  return stars ? (
                    <div style={{marginTop:10, fontSize:13, color:'var(--amber-600)', fontWeight:700}}>
                      {'★'.repeat(stars)}<span className="muted" style={{fontWeight:400, marginLeft:6, fontSize:11}}>평가함</span>
                    </div>
                  ) : (
                    <button type="button" className="btn btn-ghost btn-sm" style={{marginTop:10, width:'100%'}}
                      onClick={() => setRatingVisit(v)}>별점 평가</button>
                  );
                })()}
              </div>
            </div>
          );
        })}

        {data.recent_vitals.length > 0 && (
          <>
            <div style={{fontSize:11, fontWeight:700, color:'var(--ink-3)', letterSpacing:'0.06em', margin:'4px 0 10px'}}>최근 활력</div>
            {data.recent_vitals.map((v) => (
              <div key={v.id} className="card" style={{padding:'12px 14px', marginBottom:8}}>
                <div style={{display:'flex', alignItems:'center', gap:14, fontSize:11}}>
                  <span className="muted">{new Date(v.at).toLocaleDateString('ko-KR')}</span>
                  {v.bp && <span><b>혈압</b> {v.bp}</span>}
                  {v.hr && <span><b>맥박</b> {v.hr}</span>}
                  {v.temp && <span><b>체온</b> {v.temp}°</span>}
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      <RoleTabBar active="schedule"/>
      <HbarG/>
      {ratingVisit && (
        <RatingModal
          visit={ratingVisit}
          onClose={() => setRatingVisit(null)}
          onSubmitted={(stars) => {
            setMyRatings((m) => ({ ...m, [ratingVisit.id]: stars }));
            setRatingVisit(null);
          }}
        />
      )}
    </div>
  );
}

// 복약 화면 — 복약 안내 알림(/m/meds)의 목적지. "오늘 무슨 약을, 언제"에 답한다.
// 같은 mobile/case API의 medications[]를 재사용하고 표시만 한다(어르신은 읽기 전용).
// 디자인 언어는 홈/일정과 동일(다크 요약카드+3타일·시간대별 목록). 설계: docs/elder-meds-screen-design.md
function MedCenter() {
  const [data, setData] = React.useState(null);
  const [err, setErr]   = React.useState(null);
  const [showStopped, setShowStopped] = React.useState(false);
  // 오늘 복용 체크된 (약id:슬롯) 키 집합. data 로드 시 taken_today 로 초기화, 토글 시 낙관적 갱신.
  const [taken, setTaken] = React.useState(() => new Set());
  const { user } = useCurrentUser();
  const isElder = user?.role === "citizen";

  // 알림(리마인더/미복약)의 ?s=<슬롯>로 진입하면 그 시간대 그룹으로 스크롤·하이라이트.
  const targetSlot = MED_SLOT_BY_KEY[new URLSearchParams(window.location.search).get("s") || ""] || null;
  const [highlight, setHighlight] = React.useState(targetSlot);
  const slotRefs = React.useRef({});

  // 데이터가 차고 타깃 슬롯이 있으면 해당 그룹으로 스크롤 + 잠시 강조 후 해제.
  React.useEffect(() => {
    if (!data || !targetSlot) return;
    const el = slotRefs.current[targetSlot];
    if (el) el.scrollIntoView({ behavior: "smooth", block: "center" });
    const t = window.setTimeout(() => setHighlight(null), 2600);
    return () => window.clearTimeout(t);
  }, [data, targetSlot]);

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch("/api/v1/mobile/case", { credentials: "same-origin" });
        const body = await r.json().catch(() => null);
        if (cancelled) return;
        if (!r.ok) {
          if (r.status === 401)      setErr("로그인이 필요합니다.");
          else if (r.status === 403) setErr(body?.message || "이 정보를 볼 권한이 없습니다.");
          else if (r.status === 404) setErr(body?.message || "표시할 복약 정보가 없습니다.");
          else                       setErr(apiErrorMessage(body, r.status));
          return;
        }
        const init = new Set();
        ((body.elderly && body.elderly.medications) || []).forEach((m) =>
          (m.taken_today || []).forEach((s) => init.add(`${m.id}:${s}`)));
        setErr(null);
        setTaken(init);
        setData(body);
      } catch (e) {
        if (!cancelled) setErr(apiErrorMessage(e));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  // 복용 체크 토글 — 낙관적 갱신 후 서버 반영, 실패 시 롤백.
  const toggle = async (med, slot) => {
    const key  = `${med.id}:${slot}`;
    const next = !taken.has(key);
    setTaken((prev) => { const s = new Set(prev); next ? s.add(key) : s.delete(key); return s; });
    try {
      const r = await fetch(`/api/v1/medications/${med.id}/intake`, {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ slot, taken: next }),
      });
      if (!r.ok) throw new Error(String(r.status));
    } catch {
      setTaken((prev) => { const s = new Set(prev); next ? s.delete(key) : s.add(key); return s; }); // 롤백
    }
  };

  if (err) {
    if (isElder) return <ElderNotice active="" title="복약"
      desc={<>약 정보를 불러오지 못했어요.<br/>계속 안 되면 상담센터로 전화 주세요.</>} />;
    return <div className="app" style={{padding:40, color:'var(--rose-500)'}}>API 오류: {err}</div>;
  }
  if (!data) return <div className="app muted" style={{padding:40, fontSize: isElder ? 15 : undefined}}>불러오는 중…</div>;

  // mobile/case 응답은 medications 를 elderly 객체 안에 둔다(data.elderly.medications).
  const meds    = (data.elderly && data.elderly.medications) || [];
  const active  = meds.filter((m) => !m.stopped_at);
  const stopped = meds.filter((m) => m.stopped_at);

  // 슬롯별 그룹 + 시간 미지정. 한 약이 여러 슬롯이면 각 슬롯에 반복 노출(지금 뭘 먹지에 답).
  const bySlot = {};
  MED_SLOTS.forEach((s) => (bySlot[s] = []));
  const noSlot = [];
  active.forEach((m) => {
    const slots = parseMedSlots(m.time_of_day);
    if (slots.length === 0) noSlot.push(m);
    else slots.forEach((s) => bySlot[s].push(m));
  });
  const count = (s) => bySlot[s].length;

  const groups = [...MED_SLOTS.map((s) => ({ label: s, meds: bySlot[s] })), { label: "시간 미지정", meds: noSlot }]
    .filter((g) => g.meds.length > 0);

  // 1회 복용 = (약 × 슬롯). 전체/완료 doses 와 슬롯별 진행 집계.
  const isTaken     = (id, slot) => taken.has(`${id}:${slot}`);
  const totalDoses  = groups.reduce((n, g) => n + g.meds.length, 0);
  const takenDoses  = groups.reduce((n, g) => n + g.meds.filter((m) => isTaken(m.id, g.label)).length, 0);
  const takenIn     = (s) => bySlot[s].filter((m) => isTaken(m.id, s)).length;
  const allDone     = totalDoses > 0 && takenDoses === totalDoses;
  const pct         = totalDoses > 0 ? Math.round((takenDoses / totalDoses) * 100) : 0;

  // 약 보조문구 "용량 · 횟수" — 빈 값은 생략(빈 ' · ' 방지).
  const sub = (m) => [m.dosage, m.frequency].filter(Boolean).join(" · ");

  return (
    <div className="app" style={{ background: "var(--bg)", overflow: "auto", display: "flex", flexDirection: "column" }}>
      <SbarG/>

      {/* ① 헤더 */}
      <div style={{ padding: "8px 22px 6px", display: "flex", alignItems: "center", gap: 12, flexShrink: 0 }}>
        <a onClick={() => history.back()} aria-label="뒤로"
           style={{ width: 40, height: 40, display: "grid", placeItems: "center", borderRadius: 12, background: "var(--surface)", color: "var(--ink-1)", fontSize: 22, cursor: "pointer", textDecoration: "none" }}>‹</a>
        <div style={{ fontSize: 20, fontWeight: 800 }}>복약</div>
      </div>

      {/* ② 다크 요약 카드 — 오늘 복용 진행률 중심 */}
      <div style={{ margin: "8px 22px 0", padding: 18, background: "linear-gradient(135deg, #2A241F, #3E3329)", color: "#F5EBD8", borderRadius: 18, position: "relative", overflow: "hidden", flexShrink: 0 }}>
        <div style={{ position: "absolute", top: -40, right: -30, width: 140, height: 140, borderRadius: "50%", background: allDone ? "rgba(143,200,168,0.18)" : "rgba(232,130,91,0.15)" }} />
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div className="avatar lg" style={{ background: allDone ? "linear-gradient(135deg, #9BC3A6, #4F8A72)" : "linear-gradient(135deg, #EFB287, #E8825B)" }}>
            <span style={{ width: 22, height: 22, display: "grid", placeItems: "center", fontSize: 22 }}>{allDone ? Ic.check : Ic.pill}</span>
          </div>
          <div style={{ minWidth: 0 }}>
            <div style={{ fontSize: 13, opacity: .7 }}>오늘의 복약</div>
            <div style={{ fontSize: 18, fontWeight: 800, color: "#fff" }}>{totalDoses > 0 ? `${takenDoses} / ${totalDoses} 복용` : "복용 중인 약 없음"}</div>
            {totalDoses > 0 && (
              <div style={{ fontSize: 12, color: allDone ? "#9BD0AA" : "#A89A7C", marginTop: 2 }}>
                {allDone ? "오늘 약을 다 드셨어요. 잘하셨어요!" : `아직 ${totalDoses - takenDoses}가지 남았어요`}
              </div>
            )}
          </div>
          {totalDoses > 0 && (
            <span style={{ marginLeft: "auto", padding: "4px 10px", background: "rgba(143,200,168,0.20)", color: "#9BD0AA", borderRadius: 999, fontSize: 12, fontWeight: 700, whiteSpace: "nowrap" }}>{allDone ? "완료" : "오늘"}</span>
          )}
        </div>
        {totalDoses > 0 && (
          <div style={{ height: 7, borderRadius: 999, background: "rgba(255,255,255,0.12)", overflow: "hidden", marginTop: 14 }}>
            <div style={{ height: "100%", width: `${pct}%`, background: "#9BD0AA", borderRadius: 999, transition: "width .15s" }} />
          </div>
        )}
        <div style={{ display: "flex", gap: 8, marginTop: 12 }}>
          {MED_SLOTS.slice(0, 3).map((s) => {
            const c = count(s), t = takenIn(s), full = c > 0 && t === c;
            return (
              <div key={s} style={{ flex: 1, padding: 10, background: "rgba(255,255,255,0.06)", borderRadius: 10, overflow: "hidden" }}>
                <div style={{ fontSize: 11, opacity: .65 }}>{s}</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: full ? "#9BD0AA" : "#fff", marginTop: 2 }}>{c === 0 ? "—" : `${t}/${c}`}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* ③ 오늘 드실 약 — 시간대별 + 복용 체크(탭하면 토글) */}
      <div style={{ padding: "18px 22px 0" }}>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 10 }}>오늘 드실 약</div>
        <div className="card" style={{ padding: "4px 18px", borderRadius: 14 }}>
          {groups.length === 0 && <div className="muted" style={{ fontSize: 14, padding: "12px 0" }}>지금 복용 중인 약이 없어요.</div>}
          {groups.map((g, gi) => (
            <div key={g.label} ref={(el) => (slotRefs.current[g.label] = el)}
                 style={{ padding: "10px 0", borderTop: gi > 0 ? "1px solid var(--border-soft)" : "none",
                          background: highlight === g.label ? "var(--orange-50)" : "transparent",
                          borderRadius: 10, transition: "background .4s" }}>
              <div style={{ fontSize: 13, fontWeight: 700, color: highlight === g.label ? "var(--orange-700)" : "var(--ink-3)", marginBottom: 4 }}>{g.label}</div>
              {g.meds.map((m) => {
                const on = isTaken(m.id, g.label);
                return (
                  <div key={m.id + ":" + g.label} role="button" tabIndex={0}
                       aria-pressed={on} aria-label={`${m.name} ${on ? "복용함" : "복용 체크"}`}
                       onClick={() => toggle(m, g.label)}
                       style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 0", cursor: "pointer" }}>
                    {/* 체크 동그라미 — 미복용: 빈 원 / 복용: 초록 채움+체크 */}
                    <span aria-hidden style={{ flex: "0 0 auto", width: 30, height: 30, borderRadius: 999, display: "grid", placeItems: "center",
                      background: on ? "var(--green-500)" : "var(--surface)", border: on ? "none" : "2px solid var(--border)", color: "#fff", transition: "background .12s" }}>
                      {on && <span style={{ width: 16, height: 16, display: "inline-block" }}>{Ic.check}</span>}
                    </span>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontSize: 16, fontWeight: 700, color: on ? "var(--ink-3)" : "var(--ink-1)" }}>{m.name}</div>
                      {m.note && <div style={{ fontSize: 12, color: "var(--ink-3)", marginTop: 1 }}>{m.note}</div>}
                    </div>
                    {sub(m) && <div style={{ fontSize: 13, color: "var(--ink-3)", whiteSpace: "nowrap" }}>{sub(m)}</div>}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
        {totalDoses > 0 && <div style={{ fontSize: 12, color: "var(--ink-3)", margin: "8px 2px 0" }}>약을 드신 뒤 동그라미를 눌러 표시해 주세요.</div>}
      </div>

      {/* ④ 중단한 약 (접힘) */}
      {stopped.length > 0 && (
        <div style={{ padding: "18px 22px 0" }}>
          <div role="button" tabIndex={0} onClick={() => setShowStopped((v) => !v)}
               style={{ display: "flex", alignItems: "center", justifyContent: "space-between", cursor: "pointer" }}>
            <span style={{ fontSize: 15, fontWeight: 700 }}>중단한 약 ({stopped.length})</span>
            <span style={{ fontSize: 13, color: "var(--orange-600)", fontWeight: 700 }}>{showStopped ? "접기" : "펼치기"}</span>
          </div>
          {showStopped && (
            <div className="card" style={{ padding: "4px 18px", borderRadius: 14, marginTop: 10 }}>
              {stopped.map((m, i) => (
                <div key={m.id} style={{ display: "flex", alignItems: "center", gap: 10, padding: "12px 0", borderTop: i > 0 ? "1px solid var(--border-soft)" : "none" }}>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontSize: 15, fontWeight: 600, color: "var(--ink-2)" }}>{m.name}</div>
                    {sub(m) && <div style={{ fontSize: 12, color: "var(--ink-3)" }}>{sub(m)}</div>}
                  </div>
                  <span className="badge badge-gray" style={{ fontSize: 13 }}>중단</span>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* ⑤ 도움 — 약 변경은 어르신이 직접 못 하므로 사람 연결 */}
      <div style={{ padding: "18px 22px 0" }}>
        <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 10 }}>약을 바꾸셨나요?</div>
        <div className="card" style={{ padding: "4px 18px", borderRadius: 14 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 0", color: "var(--ink-1)" }}>
            <span style={{ width: 22, height: 22, color: "var(--green-600)", display: "inline-block" }}>{Ic.user}</span>
            <span style={{ flex: 1, fontSize: 14, fontWeight: 600 }}>약 변경은 담당 선생님께 말씀해 주세요</span>
          </div>
          <a href={`tel:${ELDER_CONSULT_TEL}`} style={{ display: "flex", alignItems: "center", gap: 12, padding: "14px 0", borderTop: "1px solid var(--border-soft)", textDecoration: "none", color: "var(--ink-1)" }}>
            <span style={{ width: 22, height: 22, color: "var(--green-600)", display: "inline-block" }}>{Ic.phone}</span>
            <span style={{ flex: 1, fontSize: 14, fontWeight: 600 }}>상담센터 전화</span>
            <span style={{ fontSize: 12, color: "var(--ink-3)" }}>{ELDER_CONSULT_TEL}</span>
          </a>
        </div>
      </div>

      <div style={{ height: 14 }} />
      <div style={{ marginTop: "auto" }}><RoleTabBar active="meds"/></div>
      <HbarG/>
    </div>
  );
}

// 4. 보호자 마이페이지 — 프로필 조회/편집, 비밀번호 변경, 로그아웃.
// 매니저용 MgrMe와 의도적으로 별도 컴포넌트. 보호자/어르신은 어르신·매니저 연계
// 정보를 노출해야 하고, 하단 탭바도 다르며, 향후 알림 설정·구독 흐름이 추가될
// 가능성이 보호자 쪽이 크므로 한 화면으로 합치지 않는다.
function GuardianMe() {
  const { user, loaded } = useCurrentUser();
  const isElder = user?.role === "citizen";
  const [busy, setBusy] = React.useState(false);

  const doLogout = async () => {
    if (busy) return;
    if (!window.confirm("로그아웃하시겠습니까?")) return;
    setBusy(true);
    try { await fetch("/api/v1/sessions", { method: "DELETE", credentials: "same-origin" }); }
    catch { /* 네트워크 실패해도 로그인 화면으로 이동 */ }
    finally { window.location.href = "/login"; }
  };

  return (
    <div className="app" style={{background:'var(--bg)', overflow:'hidden'}}>
      <SbarG/>
      <div style={{padding:'10px 22px 8px'}}>
        <div style={{fontSize: isElder ? 21 : 18, fontWeight:800}}>내 정보</div>
      </div>

      {!loaded && <div className="muted" style={{padding:'30px 22px', textAlign:'center', fontSize:12}}>불러오는 중…</div>}
      {loaded && !user && (
        <div style={{padding:'30px 22px', textAlign:'center'}}>
          <div className="muted" style={{fontSize:13, marginBottom:14}}>로그인이 필요합니다.</div>
          <a href="/login" className="btn btn-primary" style={{padding:'10px 22px', borderRadius:10, textDecoration:'none'}}>로그인</a>
        </div>
      )}

      {user && (
        <div style={{padding:'4px 22px 0', flex:1, overflow:'auto'}}>
          {/* 신원 카드 */}
          <div className="card" style={{padding:'16px 18px', marginBottom:14, display:'flex', alignItems:'center', gap:14}}>
            <div className="avatar lg" style={{width:54, height:54, fontSize:20, overflow:'hidden', background:'var(--orange-50)', color:'var(--orange-700)'}}>
              {user.avatar_url
                ? <img src={user.avatar_url} alt="프로필 사진" style={{width:'100%', height:'100%', objectFit:'cover'}}/>
                : (user.name || '?')[0]}
            </div>
            <div style={{flex:1, minWidth:0}}>
              <div style={{fontSize: isElder ? 18 : 16, fontWeight:800}}>{user.name} 님</div>
              {/* 어르신(citizen)은 자기를 "보호자"로 부르지 않는다 — 역할 라벨/보호자 표기 생략. */}
              {!isElder && (
                <div className="muted" style={{fontSize:11.5, marginTop:2}}>
                  {user.role_label}
                  {user.elderly_name ? ` · ${user.elderly_name} 보호자` : ''}
                </div>
              )}
              <div className="muted" style={{fontSize: isElder ? 13 : 10.5, marginTop:2, overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap'}}>{user.email}</div>
            </div>
          </div>

          <AvatarEditor user={user}/>
          <ProfileEditor user={user}/>
          <PasswordChanger/>
          <NotificationPreferences/>
          <AccountWithdraw/>

          {/* 도움말·상담센터 — 어르신은 하단 탭에 '도움'이 없으므로 내 정보에서 닿게 한다 */}
          {isElder && (
            <>
              <div style={{fontSize:13, fontWeight:600, color:'var(--ink-3)', marginBottom:8}}>도움</div>
              <div className="card" style={{padding:'2px 16px', borderRadius:14, marginBottom:18}}>
                <a href="/help" style={{display:'flex', alignItems:'center', gap:12, padding:'14px 0', textDecoration:'none', color:'var(--ink-1)'}}>
                  <span style={{width:22, height:22, color:'var(--orange-600)', display:'inline-block'}}>{Ic.help}</span>
                  <span style={{flex:1, fontSize:15, fontWeight:600}}>도움말 보기</span>
                  <span aria-hidden style={{color:'var(--ink-3)', fontSize:18}}>›</span>
                </a>
                <a href={`tel:${ELDER_CONSULT_TEL}`} style={{display:'flex', alignItems:'center', gap:12, padding:'14px 0', borderTop:'1px solid var(--border-soft)', textDecoration:'none', color:'var(--ink-1)'}}>
                  <span style={{width:22, height:22, color:'var(--green-600)', display:'inline-block'}}>{Ic.phone}</span>
                  <span style={{flex:1, fontSize:15, fontWeight:600}}>상담센터 전화</span>
                  <span style={{fontSize:13, color:'var(--ink-3)'}}>{ELDER_CONSULT_TEL}</span>
                </a>
              </div>
            </>
          )}

          {/* 정책 */}
          <div style={{fontSize:11, fontWeight:700, color:'var(--ink-3)', letterSpacing:'0.06em', marginBottom:6}}>정책</div>
          <div className="card" style={{padding:0, marginBottom:18, overflow:'hidden'}}>
            {[
              { l: '이용약관',         href: '/m/terms'   },
              { l: '개인정보처리방침', href: '/m/privacy' },
            ].map((it, i) => (
              <a key={i} href={it.href}
                 style={{display:'flex', alignItems:'center', padding:'12px 14px', textDecoration:'none', color:'inherit', borderTop: i === 0 ? 'none' : '1px solid var(--border-soft)'}}>
                <div style={{flex:1, fontSize:13, fontWeight:600}}>{it.l}</div>
                <span style={{color:'var(--ink-3)', fontSize:14}}>›</span>
              </a>
            ))}
          </div>

          <button type="button" onClick={doLogout} disabled={busy}
                  style={{width:'100%', padding:'12px 0', background:'var(--surface)', color:'var(--rose-500)', border:'1px solid var(--rose-100)', borderRadius:12, fontSize:13.5, fontWeight:700, cursor: busy ? 'default' : 'pointer', marginBottom:14}}>
            {busy ? '처리 중…' : '로그아웃'}
          </button>
        </div>
      )}

      <RoleTabBar active="me"/>
      <HbarG/>
    </div>
  );
}

// 매니저 상태 → 배지 색/라벨. dashboard-guardian.tsx의 MGR_STATUS_BADGE와 동일
// 의도지만 컴포넌트 트리가 다르고 두 화면이 함께 손대지 않는 한 영향 범위가
// 갈리므로 의도적으로 두 곳에 둔다. 추후 3번째 사용처가 생기면 common.tsx로 승격.
const MGR_STATUS_BADGE = {
  available:  { c: 'green',  l: '가용'         },
  busy:       { c: 'amber',  l: '다른 방문 중' },
  overloaded: { c: 'rose',   l: '과부하'       },
  moving:     { c: 'orange', l: '이동 중'      },
  offline:    { c: 'gray',   l: '오프라인'     },
};
const VISIT_STATUS_LABEL = { planned: '예정', in_progress: '진행중', completed: '완료', cancelled: '취소' };

// 5. 보호자 → 담당 매니저 상세. /api/v1/dashboard/guardian 응답을 재사용 —
// 매니저 카드(이름/자격/소속/별점/상태/전화) + 이 매니저와의 최근 방문만 필터링.
// 미배정/제안 단계는 별도 빈 상태로 분기해 "전화 걸기"가 잘못 활성화되지 않게 한다.
function GuardianManager() {
  const [data, setData] = React.useState(null);
  const [err, setErr]   = React.useState(null);

  React.useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch("/api/v1/dashboard/guardian", { credentials: "same-origin" });
        const body = await r.json().catch(() => null);
        if (cancelled) return;
        if (!r.ok) {
          if (r.status === 401)      setErr("로그인이 필요합니다.");
          else if (r.status === 403) setErr(body?.message || "접근 권한이 없습니다.");
          else                       setErr(apiErrorMessage(body, r.status));
          return;
        }
        setErr(null);
        setData(body);
      } catch (e) {
        if (!cancelled) setErr(apiErrorMessage(e));
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="app" style={{background:'var(--bg)', overflow:'hidden'}}>
      <SbarG/>
      <div style={{padding:'8px 22px 12px', display:'flex', alignItems:'center', gap:14}}>
        <a onClick={() => history.back()}
           style={{width:32, height:32, display:'grid', placeItems:'center', borderRadius:10, background:'var(--surface)', color:'var(--ink-1)', cursor:'pointer', textDecoration:'none'}}>‹</a>
        <div style={{flex:1}}>
          <div style={{fontSize:11, color:'var(--ink-3)'}}>담당 매니저</div>
          <div style={{fontSize:14, fontWeight:700}}>{data?.elderly?.name ? `${data.elderly.name} 어르신` : ''}</div>
        </div>
      </div>

      {err && (
        <div role="alert" style={{margin:'0 22px 8px', padding:'10px 12px', background:'var(--rose-50)', color:'var(--rose-500)', borderRadius:10, fontSize:12.5}}>{err}</div>
      )}
      {!err && !data && (
        <div className="muted" style={{padding:'30px 22px', textAlign:'center', fontSize:12}}>불러오는 중…</div>
      )}

      {data && <GuardianManagerBody data={data}/>}

      <GuardianTabBar active="manager"/>
      <HbarG/>
    </div>
  );
}

function GuardianManagerBody({ data }) {
  const mgr = data.assigned_manager;

  // 미배정 / 제안 단계 분기. 두 케이스의 메시지가 달라서 분리해서 안내.
  if (!mgr) {
    return (
      <div style={{flex:1, padding:'30px 22px', textAlign:'center'}}>
        <div style={{fontSize:28, marginBottom:8}}>🤝</div>
        <div style={{fontSize:14, fontWeight:700, marginBottom:6}}>아직 담당 매니저가 배정되지 않았어요</div>
        <div className="muted" style={{fontSize:12, lineHeight:1.6}}>케어 신청 접수 후 권역 관리자가 매니저를 배정합니다. 매칭이 완료되면 알림으로 안내드려요.</div>
      </div>
    );
  }

  const visitsWithThisMgr = (data.recent_visits || []).filter(v => v.care_manager_id === mgr.id);
  const statusBadge = MGR_STATUS_BADGE[mgr.status];
  const hasRating = typeof mgr.rating === "number" && mgr.rating > 0;

  return (
    <div style={{padding:'4px 22px 0', flex:1, overflow:'auto'}}>
      {/* 매니저 카드 — 헤더/이름/상태 */}
      <div className="card" style={{padding:'16px 18px', marginBottom:14}}>
        <div style={{display:'flex', alignItems:'center', gap:14}}>
          <div className="avatar lg green" style={{width:54, height:54, fontSize:20}}>{(mgr.name || '?')[0]}</div>
          <div style={{flex:1, minWidth:0}}>
            <div style={{fontSize:16, fontWeight:800}}>{mgr.name} 매니저</div>
            <div className="muted" style={{fontSize:11.5, marginTop:2}}>{mgr.qualification}{mgr.organization_name ? ` · ${mgr.organization_name}` : ''}</div>
            <div style={{display:'flex', gap:6, alignItems:'center', marginTop:6, flexWrap:'wrap'}}>
              {mgr.proposed
                ? <span className="badge badge-amber">제안 단계</span>
                : statusBadge && <span className={"badge badge-" + statusBadge.c}>{statusBadge.l}</span>}
              {hasRating && (
                <span style={{fontSize:11.5, color:'var(--ink-2)', fontWeight:700, display:'inline-flex', alignItems:'center', gap:3}}>
                  <span style={{color:'var(--amber-500)'}}>★</span>{mgr.rating.toFixed(1)}
                  {mgr.ratings_count > 0 && <span className="muted" style={{fontWeight:400, marginLeft:2}}>({mgr.ratings_count})</span>}
                </span>
              )}
            </div>
          </div>
        </div>

        {/* 연락 — 전화/메시지 나란히. 제안 단계엔 둘 다 비활성(임의 연락 방지).
            전화는 번호 없으면 비활성이지만, 메시지는 앱 내 채널이라 번호와 무관하게 가능. */}
        <div style={{marginTop:14, display:'flex', gap:8}}>
          {mgr.phone && !mgr.proposed ? (
            <a href={`tel:${mgr.phone}`} className="btn btn-primary"
               style={{flex:1, display:'flex', alignItems:'center', justifyContent:'center', gap:7, padding:'11px 0', borderRadius:12, fontSize:13.5, fontWeight:700, textDecoration:'none'}}>
              <span style={{width:18, height:18, display:'inline-block'}}>{Ic.phone}</span>
              <span>전화 걸기</span>
            </a>
          ) : (
            <button type="button" disabled
              title={mgr.proposed ? "매칭 확정 후 연락 가능합니다" : "전화번호가 등록되어 있지 않습니다"}
              style={{flex:1, display:'flex', alignItems:'center', justifyContent:'center', gap:7, padding:'11px 0', borderRadius:12, fontSize:13.5, fontWeight:700, background:'var(--surface)', color:'var(--ink-3)', border:'1px solid var(--border-soft)', cursor:'not-allowed'}}>
              <span style={{width:18, height:18, display:'inline-block'}}>{Ic.phone}</span>
              <span>{mgr.proposed ? '확정 후 가능' : '번호 미등록'}</span>
            </button>
          )}
          {!mgr.proposed ? (
            <a href={`/m/chat?care_manager_id=${mgr.id}`} aria-label={`${mgr.name} 매니저와 메시지`}
               style={{flex:1, display:'flex', alignItems:'center', justifyContent:'center', gap:7, padding:'11px 0', borderRadius:12, fontSize:13.5, fontWeight:700, textDecoration:'none', background:'var(--surface)', color:'var(--orange-600)', border:'1px solid var(--orange-300)'}}>
              <span style={{width:18, height:18, display:'inline-block'}}>{Ic.chat}</span>
              <span>메시지</span>
            </a>
          ) : (
            <button type="button" disabled title="매칭 확정 후 대화 가능합니다"
              style={{flex:1, display:'flex', alignItems:'center', justifyContent:'center', gap:7, padding:'11px 0', borderRadius:12, fontSize:13.5, fontWeight:700, background:'var(--surface)', color:'var(--ink-3)', border:'1px solid var(--border-soft)', cursor:'not-allowed'}}>
              <span style={{width:18, height:18, display:'inline-block'}}>{Ic.chat}</span>
              <span>확정 후 가능</span>
            </button>
          )}
        </div>
      </div>

      {/* 정보 라인 — 자격/소속/별점 표 형식 */}
      <div style={{fontSize:11, fontWeight:700, color:'var(--ink-3)', letterSpacing:'0.06em', marginBottom:6}}>매니저 정보</div>
      <div className="card" style={{padding:0, marginBottom:14, overflow:'hidden'}}>
        {[
          { l: '자격',  v: mgr.qualification || '—' },
          { l: '소속',  v: mgr.organization_name || '—' },
          { l: '평점',  v: hasRating ? `${mgr.rating.toFixed(1)} / 5.0` : '—' },
        ].map((row, i) => (
          <div key={i} style={{display:'flex', padding:'12px 14px', borderTop: i === 0 ? 'none' : '1px solid var(--border-soft)'}}>
            <div style={{flex:1, fontSize:12, color:'var(--ink-3)'}}>{row.l}</div>
            <div style={{fontSize:13, fontWeight:600}}>{row.v}</div>
          </div>
        ))}
      </div>

      {/* 이 매니저와의 방문 이력 — recent_visits 중 이 매니저만 추려 노출.
          5건 한도는 dashboard 응답이 그렇게 잘려서 옴. "전체" 링크로 timeline 이동. */}
      <div style={{display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:6}}>
        <div style={{fontSize:11, fontWeight:700, color:'var(--ink-3)', letterSpacing:'0.06em'}}>최근 방문 ({visitsWithThisMgr.length}건)</div>
        <a href="/m/timeline" style={{fontSize:11, color:'var(--orange-600)', fontWeight:600, textDecoration:'none'}}>전체 →</a>
      </div>
      <div className="card" style={{padding:14, marginBottom:18}}>
        {visitsWithThisMgr.length === 0 ? (
          <div className="muted" style={{fontSize:12, textAlign:'center', padding:'10px 0'}}>이 매니저와의 방문 기록이 아직 없습니다.</div>
        ) : visitsWithThisMgr.map((v, i) => {
          const dt = new Date(v.scheduled_at);
          const cls = v.status === 'completed' ? 'badge-green' : v.status === 'in_progress' ? 'badge-orange' : 'badge-gray';
          return (
            <div key={v.id}
                 style={{display:'flex', alignItems:'center', gap:12, padding:'10px 0', borderTop: i > 0 ? '1px solid var(--border-soft)' : 'none'}}>
              <div style={{textAlign:'center', minWidth:34}}>
                <div style={{fontSize:9, fontWeight:700, color:'var(--ink-3)'}}>{['일','월','화','수','목','금','토'][dt.getDay()]}</div>
                <div style={{fontSize:18, fontWeight:800, color:'var(--ink-1)', lineHeight:1}}>{dt.getDate()}</div>
              </div>
              <div style={{flex:1, minWidth:0, fontSize:12.5, fontWeight:600}}>
                {dt.toLocaleTimeString('ko-KR', { hour:'2-digit', minute:'2-digit' })}
              </div>
              <span className={"badge " + cls}>{VISIT_STATUS_LABEL[v.status]}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
}

// 6. 어르신 도움말 — 읽는 매뉴얼(보호자·어르신 공용 10섹션) 대신, 막혔을 때 바로
// 닿는 "큰 도움 타일 + 상담센터 전화 + 내 정보". 설계: docs/elder-screens-design.md 4.4
function ElderHelp() {
  const tiles = [
    { l: "오늘 방문",   s: "집 화면",     i: "dashboard", c: "orange", href: "/home" },
    { l: "방문 일정",   s: "언제 오나",   i: "schedule",  c: "green",  href: "/m/timeline" },
    { l: "알림",        s: "새 소식",     i: "bell",      c: "sky",    href: "/m/notify" },
    { l: "내 정보",     s: "이름·연락처", i: "user",      c: "amber",  href: "/m/guardian-me" },
  ];
  return (
    <div className="app" style={{ background: "var(--bg)", overflow: "auto", display: "flex", flexDirection: "column" }}>
      <SbarG/>
      <div style={{ padding: "12px 22px 4px" }}>
        <div style={{ fontSize: 21, fontWeight: 800 }}>도움말</div>
        <div style={{ fontSize: 15, color: "var(--ink-3)", marginTop: 2 }}>무엇을 도와드릴까요?</div>
      </div>

      {/* 상담센터 전화 — 막혔을 때 사람에게 닿는 가장 큰 길 */}
      <div style={{ padding: "14px 22px 0" }}>
        <a href={`tel:${ELDER_CONSULT_TEL}`} aria-label="상담센터에 전화하기"
           style={{ height: 64, borderRadius: 16, background: "var(--green-500)", color: "#fff", textDecoration: "none", display: "flex", alignItems: "center", justifyContent: "center", gap: 10 }}>
          <span style={{ width: 24, height: 24, display: "inline-block" }}>{Ic.phone}</span>
          <span style={{ fontSize: 18, fontWeight: 700 }}>상담센터 전화 ({ELDER_CONSULT_TEL})</span>
        </a>
      </div>

      {/* 큰 도움 타일 2×2 */}
      <div style={{ padding: "16px 22px 0", display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
        {tiles.map((t, i) => (
          <a key={i} href={t.href} className="card" style={{ padding: 16, borderRadius: 16, textDecoration: "none", color: "inherit" }}>
            <span style={{ width: 44, height: 44, borderRadius: 12, background: `var(--${t.c}-50)`, color: `var(--${t.c}-600)`, display: "grid", placeItems: "center" }}>
              <span style={{ width: 24, height: 24, display: "inline-block" }}>{Ic[t.i]}</span>
            </span>
            <div style={{ fontSize: 17, fontWeight: 700, marginTop: 12 }}>{t.l}</div>
            <div style={{ fontSize: 13, color: "var(--ink-3)", marginTop: 2 }}>{t.s}</div>
          </a>
        ))}
      </div>

      {/* 자세한 설명서(어르신 1인칭 매뉴얼) — 어르신은 기본적으로 안 봐도 됨 */}
      <div style={{ padding: "18px 22px 0", textAlign: "center" }}>
        <a href="/m/elder-manual" style={{ fontSize: 14, color: "var(--ink-3)", textDecoration: "none" }}>자세한 설명서 보기 ›</a>
      </div>

      <div style={{ height: 14 }} />
      <div style={{ marginTop: "auto" }}><ElderTabBar active="help" /></div>
      <HbarG/>
    </div>
  );
}

// 보호자/어르신 ↔ 매니저 양방향 대화 스레드 (/m/chat). 양 역할 공용 — 백엔드가
// my_role을 내려주면 내 메시지는 오른쪽, 상대는 왼쪽 버블로 그린다.
// URL의 elderly_id(매니저) / care_manager_id(보호자)로 스레드를 고정한다.
function MessageThread() {
  const [data, setData] = React.useState(null);
  const [err, setErr] = React.useState(null);
  const [input, setInput] = React.useState("");
  const [sending, setSending] = React.useState(false);
  const [pending, setPending] = React.useState([]);   // 낙관적 전송 중 메시지
  const [scrolled, setScrolled] = React.useState(false);
  const scrollRef = React.useRef(null);
  const taRef = React.useRef(null);

  const threadQuery = React.useMemo(() => {
    const qs = new URLSearchParams(window.location.search);
    const p = {};
    if (qs.get("elderly_id"))      p.elderly_id = qs.get("elderly_id");
    if (qs.get("care_manager_id")) p.care_manager_id = qs.get("care_manager_id");
    return p;
  }, []);

  const load = React.useCallback(async () => {
    const q = new URLSearchParams(threadQuery).toString();
    try {
      const r = await fetch(`/api/v1/messages${q ? "?" + q : ""}`, { credentials: "same-origin" });
      const body = await r.json().catch(() => null);
      if (!r.ok) { setErr(apiErrorMessage(body, r.status)); return; }
      setErr(null); setData(body);
    } catch (e) { setErr(apiErrorMessage(e)); }
  }, [threadQuery]);

  React.useEffect(() => {
    load();
    const onFocus = () => load();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [load]);

  React.useEffect(() => {
    const el = scrollRef.current;
    if (el) el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [data, pending]);

  const autosize = () => {
    const el = taRef.current; if (!el) return;
    el.style.height = "auto";
    el.style.height = Math.min(el.scrollHeight, 120) + "px";
  };

  const send = async () => {
    const text = input.trim();
    if (!text || sending || !data) return;
    const tempId = `tmp-${Date.now()}`;
    setPending((p) => [...p, { id: tempId, body: text, sender_role: data.my_role,
                              created_at: new Date().toISOString(), read_at: null, _pending: true }]);
    setInput(""); setSending(true); setErr(null);
    requestAnimationFrame(() => { if (taRef.current) taRef.current.style.height = "auto"; });
    try {
      const r = await fetch("/api/v1/messages", {
        method: "POST", credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ body: text, ...threadQuery }),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) {
        setErr(apiErrorMessage(j, r.status));
        setPending((p) => p.filter((x) => x.id !== tempId)); setInput(text);
        return;
      }
      await load();
      setPending((p) => p.filter((x) => x.id !== tempId));
    } catch (e) {
      setErr(apiErrorMessage(e));
      setPending((p) => p.filter((x) => x.id !== tempId)); setInput(text);
    } finally { setSending(false); }
  };

  // 상대(스레드 참가자) 표시명·서브타이틀·이니셜
  const otherName = data && (data.my_role === "manager"
    ? `${data.elderly?.name || "어르신"} 보호자`
    : `${data.care_manager?.name || "매니저"} 매니저`);
  const subtitle = data && (data.my_role === "manager"
    ? "보호자" : (data.care_manager?.qualification || "케어매니저"));
  const initial = (otherName || "?").trim().charAt(0);

  // 메시지(서버 + 낙관적) → 연속 그룹핑/날짜 경계 플래그 부여
  const all = data ? [...data.messages, ...pending] : [];
  const sameDay = (a, b) => a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  const dayLabel = (d) => {
    const now = new Date(); const y = new Date(now); y.setDate(now.getDate() - 1);
    if (sameDay(d, now)) return "오늘";
    if (sameDay(d, y)) return "어제";
    return `${d.getMonth() + 1}월 ${d.getDate()}일`;
  };
  const GAP = 5 * 60 * 1000;   // 5분 이상 벌어지면 새 그룹
  const rows = all.map((m, i) => {
    const d = new Date(m.created_at);
    const prev = all[i - 1], next = all[i + 1];
    const pd = prev && new Date(prev.created_at), nd = next && new Date(next.created_at);
    const showDate = !prev || !sameDay(pd, d);
    const first = showDate || prev.sender_role !== m.sender_role || (d - pd) > GAP;
    const last  = !next || !sameDay(nd, d) || next.sender_role !== m.sender_role || (nd - d) > GAP;
    return { m, d, first, last, showDate, mine: m.sender_role === data.my_role };
  });

  const timeOf = (d) => d.toLocaleTimeString("ko-KR", { hour: "2-digit", minute: "2-digit" });

  return (
    <div className="app" style={{ background: "var(--bg)", display: "flex", flexDirection: "column", height: "100%" }}>
      <SbarG/>
      <div style={{ padding: "8px 14px 10px", display: "flex", alignItems: "center", gap: 11,
                    background: "var(--bg)", transition: "box-shadow .2s", zIndex: 5,
                    boxShadow: scrolled ? "var(--shadow-sm)" : "none" }}>
        <a onClick={() => history.back()} aria-label="뒤로"
           style={{ width: 32, height: 32, display: "grid", placeItems: "center", borderRadius: 10, background: "var(--surface)", color: "var(--ink-1)", cursor: "pointer", fontSize: 20, textDecoration: "none" }}>‹</a>
        <div style={{ width: 36, height: 36, borderRadius: "50%", background: "var(--green-100)", color: "var(--green-700)", display: "grid", placeItems: "center", fontWeight: 800, fontSize: 14 }}>{initial}</div>
        <div style={{ lineHeight: 1.25 }}>
          <div style={{ fontSize: 15, fontWeight: 800 }}>{otherName || "대화"}</div>
          {subtitle && <div style={{ fontSize: 11.5, color: "var(--ink-3)" }}>{subtitle}</div>}
        </div>
      </div>

      <div ref={scrollRef} onScroll={(e) => setScrolled(e.currentTarget.scrollTop > 4)}
           style={{ flex: 1, overflow: "auto", padding: "8px 14px 16px", display: "flex", flexDirection: "column" }}>
        {err && <div role="alert" style={{ color: "var(--rose-500)", fontSize: 12.5, textAlign: "center", margin: "8px 0" }}>{err}</div>}
        {data && all.length === 0 && (
          <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, color: "var(--ink-3)" }}>
            <div style={{ width: 60, height: 60, borderRadius: "50%", background: "var(--bg-sub)", display: "grid", placeItems: "center", fontSize: 28 }}>💬</div>
            <div style={{ fontSize: 13.5, textAlign: "center", lineHeight: 1.6 }}>아직 대화가 없습니다.<br/>첫 메시지를 보내보세요.</div>
          </div>
        )}
        {rows.map(({ m, d, first, last, showDate, mine }) => (
          <React.Fragment key={m.id}>
            {showDate && (
              <div style={{ alignSelf: "center", margin: "14px 0 10px", padding: "3px 12px", borderRadius: 999, background: "var(--bg-sub)", color: "var(--ink-3)", fontSize: 11, fontWeight: 600 }}>{dayLabel(d)}</div>
            )}
            {!mine && first && (
              <div style={{ fontSize: 11, color: "var(--ink-3)", fontWeight: 600, margin: "6px 0 3px 42px" }}>{m.sender_name || otherName}</div>
            )}
            <div className="msg-in" style={{ display: "flex", justifyContent: mine ? "flex-end" : "flex-start", alignItems: "flex-end", gap: 7, marginTop: first ? 0 : 2 }}>
              {!mine && (last
                ? <div style={{ width: 30, height: 30, borderRadius: "50%", background: "var(--green-100)", color: "var(--green-700)", display: "grid", placeItems: "center", fontWeight: 800, fontSize: 12, flexShrink: 0 }}>{initial}</div>
                : <div style={{ width: 30, flexShrink: 0 }}/>)}
              {mine && last && (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: 1, marginBottom: 1 }}>
                  <span style={{ fontSize: 9.5, fontWeight: 600, color: m._pending ? "var(--ink-4)" : (m.read_at ? "var(--green-600)" : "var(--ink-4)") }}>{m._pending ? "전송 중" : (m.read_at ? "읽음" : "전송됨")}</span>
                  <span style={{ fontSize: 10, color: "var(--ink-3)" }}>{timeOf(d)}</span>
                </div>
              )}
              <div style={{ maxWidth: "72%", padding: "9px 13px", fontSize: 13.5, lineHeight: 1.5, whiteSpace: "pre-wrap", wordBreak: "break-word",
                            opacity: m._pending ? 0.6 : 1, borderRadius: 18,
                            borderTopLeftRadius:  !mine && first ? 6 : 18,
                            borderTopRightRadius:  mine && first ? 6 : 18,
                            background: mine ? "linear-gradient(135deg, var(--orange-500), var(--orange-600))" : "var(--surface)",
                            color: mine ? "#fff" : "var(--ink-1)", boxShadow: "var(--shadow-sm)" }}>{m.body}</div>
              {!mine && last && (
                <span style={{ fontSize: 10, color: "var(--ink-3)", marginBottom: 2, flexShrink: 0 }}>{timeOf(d)}</span>
              )}
            </div>
          </React.Fragment>
        ))}
      </div>

      <div style={{ padding: "10px 14px", borderTop: "1px solid var(--border-soft)", background: "var(--bg)" }}>
        <div style={{ display: "flex", alignItems: "flex-end", gap: 6, background: "var(--surface)", border: "1px solid var(--border)", borderRadius: 22, padding: "5px 6px 5px 14px" }}>
          <textarea ref={taRef} value={input} rows={1} placeholder="메시지를 입력하세요…"
            onChange={(e) => { setInput(e.target.value); autosize(); }}
            onKeyDown={(e) => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); send(); } }}
            style={{ flex: 1, resize: "none", border: "none", outline: "none", background: "transparent", color: "var(--ink-1)", fontSize: 13.5, fontFamily: "inherit", lineHeight: 1.4, padding: "6px 0", maxHeight: 120 }}/>
          <button type="button" onClick={send} disabled={sending || !input.trim()} aria-label="전송"
            style={{ width: 32, height: 32, flexShrink: 0, border: "none", borderRadius: "50%", display: "grid", placeItems: "center", cursor: input.trim() ? "pointer" : "default", transition: "all .15s",
                     background: input.trim() ? "linear-gradient(135deg, var(--orange-500), var(--orange-600))" : "var(--bg-deep)",
                     color: input.trim() ? "#fff" : "var(--ink-4)", transform: input.trim() ? "scale(1)" : "scale(.94)" }}>
            <span style={{ display: "grid", placeItems: "center", transform: "rotate(-90deg)" }}>{Ic.arrow}</span>
          </button>
        </div>
      </div>
    </div>
  );
}

export { CareApply, NotifyCenter, VisitTimeline, MedCenter, GuardianMe, GuardianManager, ElderHelp, MessageThread };
